interface RollingCaptionStackProps {
  lines: string[];
  className?: string;
  lineClassName?: string;
}

export function RollingCaptionStack({
  lines,
  className = "",
  lineClassName = "",
}: RollingCaptionStackProps) {
  const visibleLines = lines.slice(-3);
  const rows = [
    ...Array.from({ length: Math.max(0, 3 - visibleLines.length) }, () => ""),
    ...visibleLines,
  ];

  return (
    <div
      className={`grid h-[4.35em] grid-rows-3 overflow-hidden text-center leading-[1.45] ${className}`}
    >
      {rows.map((line, index) => (
        <div
          key={`${index}-${line}`}
          aria-hidden={!line}
          className={`min-w-0 overflow-hidden text-ellipsis whitespace-nowrap ${lineClassName}`}
        >
          {line || "\u00a0"}
        </div>
      ))}
    </div>
  );
}
